<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import router from "@/router";
import axios from "axios";
import { userMethods, roleMethods, roleComputed } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Edit User",
      form: {
        id: "",
        email: "",
        role: 3,
        first_name: "",
        last_name: "",
        phone: "",
        company: "",
        address_1: "",
        address_2: "",
        state: "",
        city: "",
        country: "",
        postcode: "",
        password: "",
      },
    };
  },
  methods: {
    ...userMethods,
    ...roleMethods,
    onSubmit(e) {
      e.preventDefault();
      delete this.form.email;
      this.updatedUser(this.form)
        .then(() => {
          Swal.fire("User Updated!", "", "success");
          router.push({ name: "users" });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: JSON.stringify(error),
          });
        });
    },
    onReset() {},
    roleLabel(item) {
      return `${item.name}`;
    },
    getUser(userId) {
      axios
        .get(`/user/${userId}`)
        .then((response) => {
          let user = response.data;
          this.form.id = user.id;
          this.form.email = user.email;
          this.form.role = user.roles[0].id;
          this.form.first_name = user.first_name;
          this.form.last_name = user.last_name;
          this.form.phone = user.phone;
          this.form.company = user.company;
          this.form.address_1 = user.address_1;
          this.form.address_2 = user.address_2;
          this.form.state = user.state;
          this.form.city = user.city;
          this.form.country = user.country;
          this.form.postcode = user.postcode;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: JSON.stringify(error),
          });
        });
    },
    deleteUser() {
      Swal.fire({
        title: "Do you want to delete this user",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes",
        denyButtonText: `No`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          let userId = this.form.id;
          this.removeUser(userId)
            .then(function () {
              Swal.fire("User Deleted!", "", "success");
              router.push({ name: "users" });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "An error occured",
                text: JSON.stringify(error.response.data),
              });
            });
        }
      });
    },
    sendResetPasswordLink(){
      let thisInstance = this;
      thisInstance.disableUpdateButton();
      let data = {
        email: thisInstance.form.email,
      };
      axios.post('/forgot-password', data).then(function(response){
        if(response.data.status){
          Swal.fire({
            icon: "success",
            title: "Reset link sent",
            text: 'Reset password link has been sent to this user.',
          });
          thisInstance.enableUpdateButton();
        }else{
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: response.data.message ? response.data.message : '',
          });
          thisInstance.enableUpdateButton();
        }
      }).catch(function(error){
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: error.data.message ? error.data.message : JSON.stringify(error),
          });
        thisInstance.enableUpdateButton();
      });
    },
    disableUpdateButton() {
      let resetBtn = this.$refs["reset-btn"];
      let spinner = this.$refs["reset-spinner"];
      if (resetBtn && spinner) {
        resetBtn.disabled = true;
        spinner.classList.remove("d-none");
      }
    },
    enableUpdateButton() {
      let resetBtn = this.$refs["reset-btn"];
      let spinner = this.$refs["reset-spinner"];
      if (resetBtn && spinner) {
        resetBtn.disabled = false;
        spinner.classList.add("d-none");
      }
    },
  },
  computed: {
    ...roleComputed,
  },
  mounted() {
    this.loadRoles();
    this.getUser(this.$route.params.id);
  },
};
</script>
    
<template>
  <Layout>
    <PageHeader :title="title" />
    <b-form @submit="onSubmit" @reset="onReset">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <b-form-group
                    id="user-email-group"
                    label="Email:"
                    label-for="user-email"
                  >
                    <b-form-input
                      id="user-email"
                      type="text"
                      v-model="form.email"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="user-role-group"
                    label="User Role:"
                    label-for="user-role"
                  >
                    <b-form-select
                      class="form-control"
                      id="user-role"
                      v-model="form.role"
                      :options="roles"
                      text-field="name"
                      value-field="id"
                      required
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <input type="hidden" v-model="form.id" />

              <div class="row mb-3">
                <div class="col-4">
                  <b-form-group
                    id="user-first-name-group"
                    label="First Name:"
                    label-for="user-first-name"
                  >
                    <b-form-input
                      id="user-first-name"
                      type="text"
                      v-model="form.first_name"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="user-last-name-group"
                    label="Last Name:"
                    label-for="user-last-name"
                  >
                    <b-form-input
                      id="user-last-name"
                      type="text"
                      v-model="form.last_name"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="user-phone-group"
                    label="Phone:"
                    label-for="user-phone"
                  >
                    <b-form-input
                      id="user-phone"
                      type="text"
                      v-model="form.phone"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-4">
                  <b-form-group
                    id="user-compnay-group"
                    label="Company:"
                    label-for="user-compnay"
                  >
                    <b-form-input
                      id="user-compnay"
                      type="text"
                      v-model="form.company"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="user-address-1-group"
                    label="Address 1:"
                    label-for="user-address-1"
                  >
                    <b-form-input
                      id="user-address-1"
                      type="text"
                      v-model="form.address_1"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="user-address-2-group"
                    label="Address 2:"
                    label-for="user-address-2"
                  >
                    <b-form-input
                      id="user-address-2"
                      type="text"
                      v-model="form.address_2"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-4">
                  <b-form-group
                    id="user-state-group"
                    label="State:"
                    label-for="user-state"
                  >
                    <b-form-input
                      id="user-state"
                      type="text"
                      v-model="form.state"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="user-city-group"
                    label="City:"
                    label-for="user-city"
                  >
                    <b-form-input
                      id="user-city"
                      type="text"
                      v-model="form.city"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    id="user-country-group"
                    label="Country:"
                    label-for="user-country"
                  >
                    <b-form-input
                      id="user-country"
                      type="text"
                      v-model="form.country"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-4">
                  <b-form-group
                    id="user-postcode-group"
                    label="Postcode:"
                    label-for="user-postcode"
                  >
                    <b-form-input
                      id="user-postcode"
                      type="text"
                      v-model="form.postcode"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <b-form-group
                    id="user-password-group"
                    label="New Password:"
                    label-for="user-password"
                  >
                    <b-form-input
                      id="user-password"
                      type="text"
                      v-model="form.password"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-4 d-flex flex-column align-items-start justify-content-end">
                  <button type="button" class="btn btn-outline-info" ref="reset-btn" @click="sendResetPasswordLink">
                    <span>Send reset password Link</span>
                      <div
                        class="ms-2 spinner-border spinner-border-sm d-none"
                        role="status"
                        ref="reset-spinner"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 d-flex">
                  <b-button type="submit" size="lg">Save</b-button>
                  <b-button
                    class="d-block ms-auto"
                    variant="outline-danger"
                    size="lg"
                    @click="deleteUser"
                    >Delete</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </Layout>
</template>